<ng-container *ngIf="decision">
    <kiwi-decision-content class="cell-block-y staffContent" (saved)="saveStaffDecision()">
        <div class="grid-x grid-margin-x grid-margin-y align-center align-middle">
            <div class="cell xsmall-24 xlarge-16 xxlarge-14">
                <!-- Cuisine -->
                <fieldset>
                    <legend [i18nKey]="'human.resources.cooking'"></legend>

                    <!-- Kitchen staff -->
                    <table class="_tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td></td>
                            <td [i18nKey]="'decisions.staff.contract.type'"></td>
                            <td class="_number"[i18nKey]="'human.resources.employees.number'"></td>
                            <td class="_number"[i18nKey]="'human.resources.employees.salary'"></td>
                            <td class="_number"[i18nKey]="'human.resources.employees.wage.bill'"></td>
                        </tr>

                        <!-- Head chefs, only editable if restaurant is type 3 -->
                        <tr>
                            <td [i18nKey]="'human.resources.head.chefs'"></td>
                            <td [i18nKey]="'decisions.staff.permanent.contract'"></td>
                            <td>
                                <input [(ngModel)]="decision.headChefNumber"
                                       type="number"
                                       min="{{decision.minHeadChefNumber}}"
                                       max="{{decision.maxHeadChefNumber}}"
                                       (ngModelChange)="updateCooks()"
                                       name="headChefNumber"
                                       [disabled]="decisionsReadonly || parameters.restaurantType !== 'TYPE_3'"/>
                            </td>
                            <td>
                                <kiwi-currency-input [(ngModel)]="decision.headChefSalary"
                                                     [min]="decision.minHeadChefSalary"
                                                     [max]="decision.maxHeadChefSalary"
                                                     (ngModelChange)="updateCooks()"
                                                     name="headChefSalary"
                                                     [disabled]="decisionsReadonly || parameters.restaurantType !== 'TYPE_3'"></kiwi-currency-input>
                            </td>
                            <td class="_number">{{decision.headChefNumber * decision.headChefSalary | number:'1.2'}}</td>
                        </tr>

                        <!-- Cooks, always available -->
                        <tr>
                            <td [i18nKey]="'human.resources.cooks'"></td>
                            <td [i18nKey]="'decisions.staff.permanent.contract'"></td>
                            <td>
                                <input [(ngModel)]="decision.cookNumber"
                                       type="number"
                                       min="{{decision.minCookNumber}}"
                                       max="{{decision.maxCookNumber}}"
                                       (ngModelChange)="updateCooks()"
                                       name="cookNumber"
                                       [disabled]="decisionsReadonly"/>
                            </td>
                            <td>
                                <kiwi-currency-input [(ngModel)]="decision.cookSalary"
                                                     [min]="decision.minCookSalary"
                                                     [max]="decision.maxCookSalary"
                                                     (ngModelChange)="updateCooks()"
                                                     name="cookSalary"
                                                     [disabled]="decisionsReadonly"></kiwi-currency-input>
                            </td>
                            <td class="_number">{{decision.cookNumber * decision.cookSalary | number:'1.2'}}</td>
                        </tr>

                        <!-- Commis chefs, only editable is restaurant is type 2 or 3 -->
                        <tr>
                            <td [i18nKey]="'human.resources.commis.chefs'"></td>
                            <td [i18nKey]="'decisions.staff.fixed.term.contract'"></td>
                            <td><input [(ngModel)]="decision.commisChefNumber"
                                       type="number"
                                       min="{{decision.minCommisChefNumber}}"
                                       max="{{decision.maxCommisChefNumber}}"
                                       name="commisChefNumber"
                                       (ngModelChange)="updateCooks()"
                                       [disabled]="decisionsReadonly || parameters.restaurantType === 'TYPE_1'"/></td>
                            <td>
                                <kiwi-currency-input [(ngModel)]="decision.commisChefSalary"
                                                     [min]="decision.minCommisChefSalary"
                                                     [max]="decision.maxCommisChefSalary"
                                                     (ngModelChange)="updateCooks()"
                                                     name="commisChefSalary"
                                                     [disabled]="decisionsReadonly || parameters.restaurantType === 'TYPE_1'"></kiwi-currency-input>
                            </td>
                            <td class="_number">{{decision.commisChefNumber * decision.commisChefSalary | number:'1.2'}}</td>
                        </tr>
                        </tbody>
                    </table>
                </fieldset>

                <kiwi-spacer [size]="16"></kiwi-spacer>

                <!-- Service -->
                <fieldset>
                    <!-- Service staff -->
                    <legend [i18nKey]="'human.resources.service'"></legend>

                    <table class="_tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td></td>
                            <td [i18nKey]="'decisions.staff.contract.type'"></td>
                            <td class="_number"[i18nKey]="'human.resources.employees.number'"></td>
                            <td class="_number"[i18nKey]="'human.resources.employees.salary'"></td>
                            <td class="_number"[i18nKey]="'human.resources.employees.wage.bill'"></td>
                        </tr>

                        <!-- Maitres d'hotel, only available if restaurant is type 3 -->
                        <tr>
                            <td [i18nKey]="'human.resources.maitres.d.hotel'"></td>
                            <td [i18nKey]="'decisions.staff.permanent.contract'"></td>
                            <td><input [(ngModel)]="decision.maitreDHotelNumber"
                                       type="number"
                                       min="{{decision.minMaitreDHotelNumber}}"
                                       max="{{decision.maxMaitreDHotelNumber}}"
                                       name="maitreDHotelNumber"
                                       (ngModelChange)="updateWaiters()"
                                       [disabled]="decisionsReadonly || parameters.restaurantType !== 'TYPE_3'"/></td>
                            <td>
                                <kiwi-currency-input [(ngModel)]="decision.maitreDHotelSalary"
                                                     [min]="decision.minMaitreDHotelSalary"
                                                     [max]="decision.maxMaitreDHotelSalary"
                                                     (ngModelChange)="updateWaiters()"
                                                     name="maitreDHotelSalary"
                                                     [disabled]="decisionsReadonly || parameters.restaurantType !== 'TYPE_3'"></kiwi-currency-input>
                            </td>
                            <td class="_number">{{decision.maitreDHotelNumber * decision.maitreDHotelSalary | number:'1.2'}}</td>
                        </tr>

                        <!-- Head waiters, always available -->
                        <tr>
                            <td [i18nKey]="'human.resources.head.waiters'"></td>
                            <td [i18nKey]="'decisions.staff.permanent.contract'"></td>
                            <td><input [(ngModel)]="decision.headWaiterNumber"
                                       type="number"
                                       min="{{decision.minHeadWaiterNumber}}"
                                       max="{{decision.maxHeadWaiterNumber}}"
                                       name="headWaiterNumber"
                                       (ngModelChange)="updateWaiters()"
                                       [disabled]="decisionsReadonly"/></td>
                            <td>
                                <kiwi-currency-input [(ngModel)]="decision.headWaiterSalary"
                                                     [min]="decision.minHeadWaiterSalary"
                                                     [max]="decision.maxHeadWaiterSalary"
                                                     (ngModelChange)="updateWaiters()"
                                                     name="headWaiterSalary"
                                                     [disabled]="decisionsReadonly"></kiwi-currency-input>
                            </td>
                            <td class="_number">{{decision.headWaiterNumber * decision.headWaiterSalary | number:'1.2'}}</td>
                        </tr>

                        <!-- Waiters, available in type 2 and 3 -->
                        <tr>
                            <td [i18nKey]="'human.resources.waiters'"></td>
                            <td [i18nKey]="'decisions.staff.fixed.term.contract'"></td>
                            <td><input [(ngModel)]="decision.waiterNumber"
                                       type="number"
                                       min="{{decision.minWaiterNumber}}"
                                       max="{{decision.maxWaiterNumber}}"
                                       name="waiterNumber"
                                       (ngModelChange)="updateWaiters()"
                                       [disabled]="decisionsReadonly || parameters.restaurantType === 'TYPE_1'"/></td>
                            <td>
                                <kiwi-currency-input [(ngModel)]="decision.waiterSalary"
                                                     [min]="decision.minWaiterSalary"
                                                     [max]="decision.maxWaiterSalary"
                                                     (ngModelChange)="updateWaiters()"
                                                     name="waiterSalary"
                                                     [disabled]="decisionsReadonly || parameters.restaurantType === 'TYPE_1'"></kiwi-currency-input>
                            </td>
                            <td class="_number">{{decision.waiterNumber * decision.waiterSalary | number:'1.2'}}</td>
                        </tr>
                        </tbody>
                    </table>
                </fieldset>
            </div>

            <kiwi-score-image class="cell xsmall-24 xlarge-8 xxlarge-10"
                              [imgQualityClass]="imgClass"
                              [imgType]="'_staff'"
                              [scores]="scores"></kiwi-score-image>
        </div>
    </kiwi-decision-content>
</ng-container>
